import BASEAPIFORDATA from '../api/formDataProjetos'
import BASEURLPROJETOS from '../api/projetos'
import { cadastrarTarefasPayload, atualizarTarefasPayload, anexarDocumentoPayload, cadastrarComentarioPayload, atualizarEtapaTarefa, paramsListaTarefas } from '../../interfaces/tasks'


// SERVICES PARA O CRUD DE TAREFAS

export function novaTarefa(payload: cadastrarTarefasPayload) {
    return BASEURLPROJETOS.post('/tarefas', payload)
}

export function listarTarefas (params: paramsListaTarefas) {
    return BASEURLPROJETOS.get (`/tarefas?pagina=${params.pagina}&titulo=${params.titulo}&descricao=${params.descricao}&idProjeto=${params.idProjeto}&dataInicio=${params.dataInicio}&dataTermino=${params.dataTermino}&minhasSolicitacoes=${params.minhasSolicitacoes}&situacao=${params.situacao}&responsavel=${params.responsavel}&idUsuarioAprovador=${params.idUsuarioAprovador || ""}`)
}

export function listarTarefasKanban() {
    return BASEURLPROJETOS.get(`/tarefas/kanban`)
}

export function atualizarTarefa(idTarefa: string, payload: atualizarTarefasPayload) {
    return BASEURLPROJETOS.patch(`/tarefas?idTarefa=${idTarefa}`, payload)
}

export function atualizarEtapaDaTarefa(idTarefa: string, payload: atualizarEtapaTarefa) {
    return BASEURLPROJETOS.patch(`/tarefas?idTarefa=${idTarefa}`, payload)
}

export function deletarTarefa(idTarefa: number) {
    return BASEURLPROJETOS.delete(`/tarefas?idTarefa=${idTarefa}`)
}

// SERVICES PARA O CRUD DE ANEXOS

export function anexarArquivo(idTarefa: string, payload: anexarDocumentoPayload) {
    return BASEAPIFORDATA.post(`/tarefas/anexos?idTarefa=${idTarefa}`, payload)
}

export function buscarAnexos(idTarefa: string) {
    return BASEURLPROJETOS.get(`/tarefas/anexos?idTarefa=${idTarefa}`)
}

export function deletarAnexo(idAnexo: string) {
    return BASEURLPROJETOS.delete(`/tarefas/anexos?idAnexo=${idAnexo}`)
}

// ROTAS PARA O CRUD DE COMENTÁRIOS

export function postarComentario(idTarefa: string, payload: cadastrarComentarioPayload) {
    return BASEURLPROJETOS.post(`/tarefas/comentarios?idTarefa=${idTarefa}`, payload)
}

export function listarComentarios(idTarefa: string) {
    return BASEURLPROJETOS.get(`/tarefas/comentarios?idTarefa=${idTarefa}`)
}

